<template>
    <CRow>
        <CCol col="12">
            <CAlert :color="messageColor" closeButton :show.sync="dismissCountDown" fade >{{ err_msg }} </CAlert>

            <CCard>
                <CCardHeader>
                    <strong>{{ $lang.commission.crud.edit }}</strong>
                </CCardHeader>
                <CForm novalidate @submit.prevent="onSubmit">
                    <CCardBody>
                        <CRow class="align-items-start">
                            <CCol>
                                <div class="form-group">
                                    <label class="form__label">
                                        {{ $lang.commission.form.currentPercentage }}
                                        <required_span/>
                                    </label>
                                    <input
                                        type="text"
                                        :placeholder="$lang.commission.form.currentPercentage"
                                        class="form-control"
                                        v-model="commission.currentPercentage"
                                    />
                                    <small class="error" v-if="$v.commission.$error && !$v.commission.currentPercentage.required">{{
                                        $lang.commission.validation.required.currentPercentage
                                    }}</small>
                                </div>
                            </CCol>
                            <CCol>
                                <div class="form-group">
                                    <label class="form__label">
                                        {{ $lang.commission.form.currentApplyDate }}
                                        <required_span/>
                                    </label>
                                    <input
                                        type="date"
                                        :placeholder="$lang.commission.form.currentApplyDate"
                                        class="form-control"
                                        v-model="commission.currentApplyDate"
                                    />
                                    <small class="error" v-if="$v.commission.$error && !$v.commission.currentApplyDate.required">{{
                                        $lang.commission.validation.required.currentApplyDate
                                    }}</small>
                                </div>
                            </CCol>
                            <CCol>
                                <div class="form-group">
                                    <label class="form__label">
                                        {{ $lang.commission.form.afterPercentage }}
                                    </label>
                                    <input
                                        type="text"
                                        :placeholder="$lang.commission.form.afterPercentage"
                                        class="form-control"
                                        v-model="commission.afterPercentage"
                                    />
                                </div>
                            </CCol>
                            <CCol>
                                <div class="form-group">
                                    <label class="form__label">
                                        {{ $lang.commission.form.afterApplyDate }}
                                    </label>
                                    <input
                                        type="date"
                                        :placeholder="$lang.commission.form.afterApplyDate"
                                        class="form-control"
                                        v-model="commission.afterApplyDate"
                                    />
                                </div>
                            </CCol>
                        </CRow>
                    </CCardBody>
                    <CCardFooter>
                        <div class="form-group">
                            <label class="form__label">&nbsp;</label>
                            <CButton type="submit" size="sm" color="primary">
                                <CIcon name="cil-check-circle" />
                                {{ $lang.buttons.general.crud.submit }}
                            </CButton>
                        </div>
                    </CCardFooter>
                </CForm>
            </CCard>
        </CCol>
        <CCol col="12">
            <CCard>
                <CCardHeader>
                    <div class="row">
                        <CCol sm="6" class="align-self-center">
                            <strong>{{ $lang.commission.crud.tableTitle }}</strong>
                        </CCol>
                        <CCol sm="6" class="align-self-center">
                            <div class="text-sm-right mt-3 mt-sm-0">
                                <CButtonGroup class="file-export">
                                    <CButton color="secondary" disabled>
                                        {{ $lang.buttons.export.title }}
                                    </CButton>
                                    <CButton
                                        color="danger"
                                        v-c-tooltip="$lang.buttons.export.pdf"
                                        v-on:click="exports(this,'pdf',module,'commission')">
                                        <i class="fas fa-file-pdf"></i>
                                    </CButton>
                                    <VueJsonToCsv
                                        class="btn btn-success"
                                        v-c-tooltip="$lang.buttons.export.excel"
                                        :json-data="json_data"
                                        :labels="json_label"
                                        :csv-title="json_title">
                                        <i class="fas fa-file-excel"></i>
                                    </VueJsonToCsv>
                                </CButtonGroup>
                            </div>
                        </CCol>
                    </div>
                </CCardHeader>
                <CCardBody>
                    <v-server-table
                        :key="tableKey"
                        :url="module.api.list"
                        :columns="columns"
                        :options="options"
                        :data="data"
                        @loaded="onDataLoaded">
                    </v-server-table>
                </CCardBody>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
import Vue from "vue";
import VueForm from "vue-form";
import { commission } from "/src/store/url.js";
import { Mixin } from "/src/mixins/index.js";
import options from "/src/validations/validations.js";
import { ServerTable } from "vue-tables-2";
import VueSweetalert2 from "vue-sweetalert2";
import { minLength, required } from "vuelidate/lib/validators";
import VueJsonToCsv from "vue-json-to-csv";
import { Maxlength } from "../../store/maxlength";
import store from "@/store/store";
import required_span from "../../components/layouts/general/required-span";

Vue.use(VueSweetalert2);
Vue.use(ServerTable, {}, false);
Vue.use(VueForm, options);

export default {
    name: "CommissionList",
    mixins: [Mixin],
    components: {
        VueJsonToCsv,
        required_span,
    },
    data() {
        return {
            tableKey: 0, // Add a key to force table reload
            json_data: [],
            json_label: {},
            json_title: "",
            messageColor: "success",
            err_msg: "",
            alertMessage: "",
            showAlert: false,
            dismissCountDown: 0,
            dismissCountDownS: 0,
            self: this,
            activePage: 1,
            module: commission,
            commission:{
                id:null,
                currentPercentage:null,
                currentApplyDate:null,
                afterPercentage:null,
                afterApplyDate:null,
            },
            columns: [
                this.$lang.commission.table.columns.currentPercentage,
                this.$lang.commission.table.columns.currentApplyDate,
                this.$lang.commission.table.columns.afterPercentage,
                this.$lang.commission.table.columns.afterApplyDate,
                this.$lang.commission.table.columns.isActive,
                this.$lang.commission.table.columns.createdAt,
            ],
            data: [],
            options: {
                headings: {
                    currentPercentage: this.$lang.commission.table.currentPercentage,
                    currentApplyDate: this.$lang.commission.table.currentApplyDate,
                    afterPercentage: this.$lang.commission.table.afterPercentage,
                    afterApplyDate: this.$lang.commission.table.afterApplyDate,
                    isActive: this.$lang.commission.table.isActive,
                    createdAt: this.$lang.commission.table.createdAt,
                },
                sortable: [this.$lang.commission.table.createdAt, this.$lang.commission.table.isActive],
                filterable: [this.$lang.commission.table.createdAt],
            },
        };
    },
    validations: {
        commission: {
            currentPercentage: {
                required,
            },
            currentApplyDate: {
                required,
            }
        },
    },
    mounted() {
        let self = this;
        store.commit("showLoader", false);
        self.dismissCountDown = 0;
        self.dismissCountDownS = 0;
        if (localStorage.getItem("showAlert") !== "") {
            this.setAlert(true);
        }
        this.setAlert(false);
        localStorage.setItem("showAlert", "");
    },
    watch: {
        $route: {
            immediate: true,
            handler(route) {
                if (route.query && route.query.page) {
                    this.activePage = Number(route.query.page);
                }
            },
        },
    },
    methods: {
        setAlert(value) {
            this.showAlert = value;
        },
        pageChange(val) {
            this.$router.push({ query: { page: val } });
        },
        onDataLoaded(data) {
            if (data.data.data.length > 0) {
                const activeItem = data.data.data.find(item => item.isActive === "Active");
                if (activeItem) {
                    this.commission.id = activeItem.id || '';
                    this.commission.currentPercentage = this.removePercentage(activeItem.currentPercentage) || '';
                    this.commission.currentApplyDate = this.formatDate(activeItem.currentApplyDate) || '';
                    this.commission.afterPercentage = this.removePercentage(activeItem.afterPercentage) || '';
                    this.commission.afterApplyDate = this.formatDate(activeItem.afterApplyDate) || '';
                }
            }
        },
        formatDate(dateStr) {
            if (!dateStr) return ''; // Handle null or undefined dates
            const parts = dateStr.split('-');
            if (parts.length === 3) {
                return `${parts[2]}-${parts[1]}-${parts[0]}`;
            }
            return dateStr; // Return original date if format is unexpected
        },
        removePercentage(value) {
            if(value){
                return value.replace('%', '');
            }
            return value;
        },
        onSubmit() {
            this.$v.commission.$touch();
            if (this.$v.commission.$invalid) {
                this.submitStatus = "ERROR";
            } else {
                this.submitStatus = "PENDING";
                
                setTimeout(() => {
                    let self = this;
                    const postData = {
                        after_apply_date: self.commission.afterApplyDate,
                        after_percentage:self.commission.afterPercentage,
                        current_apply_date:self.commission.currentApplyDate,
                        current_percentage:self.commission.currentPercentage
                    }
                    
                    axios.put(self.editUrlApi(self.module, self.commission.id),postData)
                    .then(function (response) {
                        if (response.data.status === 200) {
                            self.messageColor = "success";
                            self.err_msg = response.data.message;
                            self.dismissCountDown = 10;
                        } else {
                            self.messageColor = "danger";
                            self.err_msg = response.data.message;
                            self.dismissCountDown = 10;
                        }
                        // Reload the table data after the update
                        self.tableKey += 1;
                    })
                    .catch(function (error) {
                        if (error.response && error.response.status === 422) {
                            // console.log("Validation error:", error.response.data);
                            self.messageColor = "danger";
                            self.err_msg = error.response.data.error.join(", ");
                            self.dismissCountDown = 10;
                        } else {
                            // console.log("error", error.response.data.message);
                            self.messageColor = "danger";
                            self.err_msg = (error.response.data && error.response.data.message)?error.response.data.message:"An unexpected error occurred.";
                            self.dismissCountDown = 10;
                        }
                    });
                }, 500);
            }
        },
    },
};
</script>
